// import navbarItems from "../../../navbarItems/navBarItems";
import { NavLink } from "react-router-dom";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import { useEffect, useState } from "react";
import classes from "./ThemeNavigation.module.css";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useLocation } from "react-router-dom";
import * as React from "react";
import { styled } from "@mui/material/styles";
import { Fragment } from "react";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import AuthContext from "../../../store/adminStore/admin-auth-context";
import RecursiveComponent from "./RecursiveComponent";

const Accordion = styled((props) => <MuiAccordion disableGutters elevation={0} square {...props} />)(
  ({ theme }) => ({
    color: "inherit !important",
    backgroundColor: "transparent !important",
    paddingInline: "12px",
    border: `none`,
    // width: "99% !important",
    "&:not(:last-child)": {
      color: "inherit !important",
      borderBottom: 0,
    },
    "&:before": {
      color: "inherit !important",
      display: "none",
    },
  })
);
const AccordionSummary = styled((props) => {
  // console.log(props.items);
  return (
    <MuiAccordionSummary
      style={{ color: "inherit !important", width: "100% !important" }}
      {...props}
      expandIcon={
        props.items.length !== 0 ? <ExpandMoreIcon style={{ color: "inherit !important" }} /> : null
      }
    />
  );
})(({ theme }) => ({
  backgroundColor: "transparent",
  color: "inherit !important",
  width: "100% !important",

  "& .MuiAccordionSummary-expandIconWrapper": {
    color: "inherit !important",
  },
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(180deg)",
    color: "inherit !important",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
    color: "inherit !important",
    width: "100% !important",
  },
}));
const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "none",
}));

const ThemeNavigation = ({
  theme,
  systemSidebarItems,
  isLoggedIn,
  setThemeOpenSidebar,
  systemActiveNames,
}) => {
  const location = useLocation();
  const { clientAuthInfo } = React.useContext(AuthContext);
  const [expanded, setExpanded] = React.useState(location.pathname);
  const [subExpanded, setSubExpanded] = React.useState(location.pathname);

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  const handleSubChange = (panel) => (event, newExpanded) => {
    setSubExpanded(newExpanded ? panel : false);
  };
  // const handleExp = (e, to) => {
  //   console.log(to);
  //   setExpanded(to);
  // };
  useEffect(() => {
    // if (
    //   location.pathname === "/check-lists" ||
    //   location.pathname === "/check-historys"
    // ) {
    //   setExpanded("/checks");
    // }
    // if (location.pathname === "/org_poses") {
    //   setExpanded("/organizational_positions");
    // }
    const filterdNav = systemSidebarItems.filter((item) => item.items.length !== 0);
    const foundedItem = filterdNav.find((each) => {
      const allTos = each.items.map((item) => item.to);
      return allTos.includes(location.pathname);
    });
    if (foundedItem) {
      setExpanded(foundedItem.to);
    }
  }, [location.pathname]);
  const closeSidebarOnMobileHandler = (e) => {
    const viewportWidth = window.innerWidth;
    if (viewportWidth < 1200) {
      setThemeOpenSidebar(false);
    }
  };
  const allAccessbleEntities = clientAuthInfo.accessibilities
    .filter((which) => systemActiveNames.includes(which.packageName))
    .map((each) => each.selectAccessList)
    .flat(1);

  return (
    <>
      {/* {isLoggedIn ? ( */}
      <>
        {systemSidebarItems.map((navItem) => (
          <Fragment key={navItem.id}>
            {navItem.items.length === 0 ? (
              <Accordion
                expanded={expanded === location.pathname}
                onChange={handleChange(navItem.items)}
              >
                <AccordionSummary
                  aria-controls="panel2d-content"
                  id="panel2d-header"
                  items={navItem.items}
                >
                  <NavLink
                    onClick={closeSidebarOnMobileHandler}
                    to={navItem.to}
                    className={({ isActive }) =>
                      isActive
                        ? [
                            isActive
                              ? theme === "Dark"
                                ? classes.activeLinkDarkTheme
                                : classes.activeLinkBrightTheme
                              : classes.unActiveLink,
                          ].join(" ")
                        : null
                    }
                    style={{ width: "100%" }}
                  >
                    <span
                      style={{
                        display: "flex",
                        transition: "all 0.3s ease-out",
                        width: "100%",
                      }}
                    >
                      <span
                        className={classes.navIcon}
                        style={{
                          paddingInlineEnd: "12px",
                          transition: "all 0.3s ease-out !important",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {navItem.icon}
                      </span>
                      <span className={classes.navLabel}>{navItem.label}</span>
                    </span>
                  </NavLink>
                </AccordionSummary>
              </Accordion>
            ) : allAccessbleEntities.some((nav) => navItem.containerOfEntitys.includes(nav)) ? (
              <Accordion expanded={expanded === navItem.to} onChange={handleChange(navItem.to)}>
                <AccordionSummary
                  aria-controls="panel2d-content"
                  id="panel2d-header"
                  items={navItem.items}
                >
                  <Typography
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      transition: "all 0.3s ease-out !important",
                    }}
                    className={[
                      classes.spanIconContainer,
                      expanded === navItem.to
                        ? theme === "Dark"
                          ? classes.activeUCDarkTheme
                          : classes.activeUCBrightTheme
                        : null,
                    ].join(" ")}
                  >
                    <span
                      style={{
                        paddingInlineEnd: "12px",
                        transition: "all 0.3s ease-out !important",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {navItem.icon}
                    </span>
                    {navItem.label}
                  </Typography>
                </AccordionSummary>
                <RecursiveComponent
                  theme={theme}
                  navItem={navItem}
                  systemActiveNames={systemActiveNames}
                  setThemeOpenSidebar={setThemeOpenSidebar}
                />
                {/* {navItem.items.map((na) => {
                  return (
                    <Fragment key={na.id}>
                      {na.items.length === 0 ? (
                        allAccessbleEntities.includes(na.name) ? (
                          <NavLink
                            key={na.id}
                            to={na.to}
                            onClick={closeSidebarOnMobileHandler}
                            className={({ isActive }) =>
                              [
                                isActive
                                  ? theme === "Dark"
                                    ? classes.activeLinkDarkTheme
                                    : classes.activeLinkBrightTheme
                                  : classes.unActiveLink,
                                isActive
                                  ? theme === "White"
                                    ? classes.whiteThemeActiveDot
                                    : theme === "Pink"
                                    ? classes.pinkThemeActiveDot
                                    : theme === "Gradient"
                                    ? classes.gradientThemeActiveDot
                                    : theme === "Dark"
                                    ? classes.darkThemeActiveDot
                                    : theme === "Blue"
                                    ? classes.BlueThemeActiveDot
                                    : null
                                  : null,
                              ].join(" ")
                            }
                            // onClick={(e) => handleExp(e, na.to)}
                          >
                            <AccordionDetails
                              className={classes.nestedLink}
                              sx={{ paddingInlineStart: "48px", transition: "all 0.3s ease-out" }}
                            >
                              {allAccessbleEntities.includes(na.name) ? na.label : null}
                            </AccordionDetails>
                          </NavLink>
                        ) : null
                      ) : allAccessbleEntities.some((nav) => na.containerOfEntitys.includes(nav)) ? (
                        <Accordion expanded={subExpanded === na.to} onChange={handleSubChange(na.to)}>
                          <AccordionSummary
                            aria-controls="panel2d-content"
                            id="panel2d-header"
                            items={na.items}
                          >
                            <Typography
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                transition: "all 0.3s ease-out !important",
                              }}
                              className={
                                subExpanded === na.to
                                  ? theme === "Dark"
                                    ? classes.activeUCDarkTheme
                                    : classes.activeUCBrightTheme
                                  : null
                              }
                            >
                              <span
                                style={{
                                  paddingInlineEnd: "12px",
                                  transition: "all 0.3s ease-out !important",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                {na.icon}
                              </span>
                              {na.label}
                            </Typography>
                          </AccordionSummary>
                          {na.items.map((naaaa) =>
                            allAccessbleEntities.includes(naaaa.name) ? (
                              <NavLink
                                key={naaaa.id}
                                to={naaaa.to}
                                onClick={closeSidebarOnMobileHandler}
                                className={({ isActive }) =>
                                  [
                                    isActive
                                      ? theme === "Dark"
                                        ? classes.activeLinkDarkTheme
                                        : classes.activeLinkBrightTheme
                                      : classes.unActiveLink,
                                    isActive
                                      ? theme === "White"
                                        ? classes.whiteThemeActiveDot
                                        : theme === "Pink"
                                        ? classes.pinkThemeActiveDot
                                        : theme === "Gradient"
                                        ? classes.gradientThemeActiveDot
                                        : theme === "Dark"
                                        ? classes.darkThemeActiveDot
                                        : theme === "Blue"
                                        ? classes.BlueThemeActiveDot
                                        : null
                                      : null,
                                  ].join(" ")
                                }
                                // onClick={(e) => handleExp(e, naaaa.to)}
                              >
                                <AccordionDetails
                                  className={classes.nestedLink}
                                  sx={{ paddingInlineStart: "48px", transition: "all 0.3s ease-out" }}
                                >
                                  {naaaa.label}
                                </AccordionDetails>
                              </NavLink>
                            ) : null
                          )}
                        </Accordion>
                      ) : null}
                    </Fragment>
                  );
                })} */}
              </Accordion>
            ) : null}
          </Fragment>
        ))}
      </>
      {/* ) : (
         <Accordion expanded={expanded === location.pathname} onChange={handleChange([])}>
           <AccordionSummary aria-controls="panel2d-content" id="panel2d-header" items={[]}>
             <NavLink to="/" className={({ isActive }) => (isActive ? classes.bb : null)}>
               <span style={{ display: "flex" }}>
                 <span style={{ paddingInlineEnd: "12px" }}>
                   {" "}
                   <HomeOutlinedIcon />
                 </span>
                 <MultiLanTxt tid="DASHBOARD" />
               </span>
             </NavLink>
           </AccordionSummary>
         </Accordion>
       )} */}
    </>
  );
};

export default ThemeNavigation;
